import {makeActionCreators} from '../index';

/**
 * @param {ReactReduxModal} reactReduxModal
 * @param {Object} options
 * @return {UpdateModalActions}
 */
export function buildActions(reactReduxModal, options) {
  return makeActionCreators(options.prefix, [{
    name: 'sendRequest',
    type: 'SEND_REQUEST',
  }, {
    name: 'requestSuccess',
    type: 'REQUEST_SUCCESS',
  }, {
    name: 'requestError',
    type: 'REQUEST_ERROR',
  }], reactReduxModal.actions);
}

/**
 * @typedef {ReactReduxModalActions} UpdateModalActions
 * @property {Function|ReduxActionCreator} sendRequest
 * @property {Function|ReduxActionCreator} requestSuccess
 * @property {Function|ReduxActionCreator} requestError
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux/update-modal/buildActions.js